import $ from 'jquery';

import { View } from 'backbone';

import nameTemplate from 'properties/main/file_types.ejs';
import util         from 'util/Util.js';

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class MainFileTypesView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change #filetypes' : 'updateSelectAttributes'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
        return this;
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.columnModel.get(propName);

        this.columnModel.set( propName, propVal, {silent: true});

        undoService.add({
            undo: () => {
                this.columnModel.set( propName, oldPropVal, {silent: true});
                this.render();  
            },
            redo: () => {
                this.columnModel.set( propName, propVal, {silent: true});
                this.render();  
            }
        }, textConstants.UNDO_MOVE);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.columnModel.toJSON()));
        }

        if(this.columnModel.get('filetypes')) {
            $('#filetypes').find('option[value='+this.columnModel.get('filetypes')+']').attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }

    

}

export default MainFileTypesView;
